import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
const checklist = ['All chemicals included — no surprise charges', 'Brushing, skimming & debris removal', 'Emptying skimmer and pump baskets', 'Full water chemistry testing & balancing', 'Regular equipment checks to catch issues early', 'Reliable weekly visits from a dedicated technician'];
export function WeeklyMaintenanceSection() {
  return <section id="maintenance" className="py-16 md:py-24 px-6 bg-light-gray" data-id="element-202">
      <div className="container mx-auto max-w-7xl" data-id="element-203">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-204">
          {/* Left: Text Content */}
          <div className="flex flex-col" data-id="element-205">
            <span className="text-brand-red uppercase text-sm font-bold tracking-wider mb-3" data-id="element-206">
              Weekly Maintenance
            </span>
            <h2 className="text-charcoal text-3xl md:text-4xl font-bold uppercase tracking-wide mb-6" data-id="element-207">
              Same Technician. Same Day. Every Week.
            </h2>

            <p className="text-gray-700 text-lg leading-relaxed mb-8" data-id="element-208">
              With our first-responder background, we bring a level of
              professionalism, integrity, and reliability you can count on week
              after week. Your dedicated technician knows your pool inside and
              out — no strangers, no surprises.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-209">
              {checklist.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-210">
                  <CheckCircleIcon className="w-6 h-6 text-brand-red flex-shrink-0 mt-0.5" data-id="element-211" />
                  <span className="text-gray-700 text-lg" data-id="element-212">{item}</span>
                </li>)}
            </ul>

            <a href="#contact" className="bg-brand-red hover:bg-brand-red-dark text-white rounded-lg px-8 py-4 text-lg font-bold transition-all duration-300 w-full sm:w-auto text-center self-start" data-id="element-213">
              Schedule Weekly Service
            </a>
          </div>

          {/* Right: Image */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[280px] md:h-[400px] lg:h-[550px]" data-id="element-214">
            <img src="https://cdn.magicpatterns.com/uploads/tuxBw85CJ4vJ4jEmnih3Ms/IMG_0542.jpg" alt="Clean inviting backyard pool on a sunny Arizona day" className="absolute inset-0 w-full h-full object-cover" data-id="element-215" />
          </div>
        </div>
      </div>
    </section>;
}